import { EMarkAsViewedActionType, IMarkAsViewedSucceedPayload, TMarkAsViewedSucceed } from './types';
import { TFeature } from '../../types/map';
import { actionGenerator } from '../../utils/redux/actionGenerator';

const setStatusSucceed = actionGenerator<EMarkAsViewedActionType.Succeed, IMarkAsViewedSucceedPayload>(
  EMarkAsViewedActionType.Succeed,
);

// Группа B мультипинов: тап помечает просмотренным весь пин - все его объявления, только в redux
// (без localStorage и бека: по доке просмотренность живёт до перезагрузки)
export function markPinAsViewed(feature: TFeature): TMarkAsViewedSucceed {
  // Объявление без cianId отбрасываем: пустой id в списке пометил бы все такие объявления выдачи
  const cianIds = feature.properties.offers.map(({ cianId }) => cianId).filter(Boolean);

  return setStatusSucceed({ cianIds });
}
